import React from 'react';
import { View } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import ShimmerPlaceHolder from 'react-native-shimmer-placeholder';

import { isArray as _isArray, isObject as _isObject, isString as _isString } from 'lodash';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../FoundationTestKeys';
import { withTheme, LightThemeColors } from '../Themes';

import styles from './Shimmer.styles';
import { shimmerPlaceholderConfig as _shimmerPlaceholderConfig } from './Shimmer.utils';

const renderShapes = (shape, shapeSectionKey, shapeIndex, shimmerConfig) => {
  if (_isArray(shape)) {
    const direction = _isString(shape[0]) ? shape[0] : 'column';

    const shapes = shape.map((loadingShape, shapeSectionIndex) => {
      return renderShapeSection(
        loadingShape,
        shimmerConfig,
        shapeSectionKey,
        shapeIndex,
        shapeSectionIndex,
      );
    });
    return (
      <View style={styles.shapesContainer(direction)} testID={FoundationTestKeys.shimmerShapeView}>
        {shapes}
      </View>
    );
  } else if (_isObject(shape)) {
    return renderShapeSection(shape, shimmerConfig, shapeSectionKey, shapeIndex, 0);
  } else {
    return null;
  }
};

const renderShapeSection = (
  shape,
  shimmerConfig,
  shapeSectionKey,
  shapeIndex,
  shapeSectionIndex,
) => {
  const key = `${shapeIndex}-${shapeSectionKey}-${shapeSectionIndex}`;

  let style = shape.style;

  switch (shape.type) {
    case 'circle':
      style = {
        height: shape.dimension,
        width: shape.dimension,
        borderRadius: shape.dimension / 2,
        ...style,
      };
      break;
    case 'line':
      style = { ...style, width: shape.dimension };
      break;
  }
  return renderShape(style, shimmerConfig, key, shape.count);
};

const renderShape = (style, shimmerConfig, key, count) => {
  const shapes = [];
  for (let i = 0; i < count; i++) {
    shapes.push(<ShimmerPlaceHolder style={style} {...shimmerConfig} key={`${key}-${i}`} />);
  }
  return shapes;
};

const Shimmer = props => {
  const config = props.config || [];

  const { shimmerPlaceholderConfig, theme } = props;

  const _themeConfig = {
    shimmerColors: [
      theme.colors.shimmerEdgesColor,
      theme.colors.shimmerCenterColor,
      theme.colors.shimmerEdgesColor,
    ],
    LinearGradient: LinearGradient,
    ...shimmerPlaceholderConfig,
  };

  return config.map((shape, index) => {
    return (
      <View
        style={{ ...styles.shimmerContainer, ...shape.containerStyle }}
        key={`Config-Shape-${index}`}
        testID={FoundationTestKeys.shimmerContainer}
      >
        <View
          style={{ ...styles.shimmerContainer, ...shape.style }}
          testID={FoundationTestKeys.shimmerContainer2}
        >
          <View testID={FoundationTestKeys.shimmerShapeLeft}>
            {shape.left && renderShapes(shape.left, 'left', index, _themeConfig)}
          </View>
          <View style={styles.mainContainer} testID={FoundationTestKeys.shimmerShapeMain}>
            {shape.main && renderShapes(shape.main, 'main', index, _themeConfig)}
          </View>
          <View testID={FoundationTestKeys.shimmerShapeRight}>
            {shape.right && renderShapes(shape.right, 'right', index, _themeConfig)}
          </View>
        </View>
      </View>
    );
  });
};

Shimmer.defaultProps = {
  theme: LightThemeColors,
  shimmerPlaceholderConfig: _shimmerPlaceholderConfig,
};

Shimmer.propTypes = {
  config: PropTypes.array,
  shimmerPlaceholderConfig: PropTypes.object,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};

export default withTheme(Shimmer);
